import { Injectable } from '@angular/core'
import moment from 'moment'
import { Subject } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class BlockerService {
  constructor() {}
  public idBlocker$ = new Subject()

  blockerUpdate() {
    // if (localStorage.length !== 0) {
    if (localStorage.getItem('blocker')) {
      let oldBlockerData = JSON.parse(localStorage.getItem('blocker'))
      if (oldBlockerData.blockedFor && !moment(moment.now()).isAfter(oldBlockerData.blockedFor)) {
      } else {
        if (oldBlockerData.attemptTime && moment(oldBlockerData.attemptTime).isAfter(moment.now() - 36e5)) {
          let blockerData = {
            attemptTime: oldBlockerData.attemptTime,
            attempt: oldBlockerData.attempt + 1,
            blockedFor: oldBlockerData.attempt + 1 > 2 ? moment.now() + 36e5 * 24 : null,
          }
          localStorage.setItem('blocker', JSON.stringify(blockerData))
        } else {
          let blockerData = {
            attemptTime: moment.now(),
            attempt: 1,
            blockedFor: null,
          }
          localStorage.setItem('blocker', JSON.stringify(blockerData))
        }
      }
    } else {
      let blockerData = {
        attemptTime: moment.now(),
        attempt: 1,
      }
      localStorage.setItem('blocker', JSON.stringify(blockerData))
    }
    // } else {
    // let attempt = this._cookie.get('attempt') || 0
    // let attemptTime = this._cookie.get('attemptTime') || undefined
    // let blockedFor = this._cookie.get('blockerFor') || undefined
    // // this._cookie.set('attempt', `${+attempt + 1}`)
    // // this._cookie.set('attemptTime', `${new Date()}`)
    // if (attemptTime) {
    //   // let oldBlockerData = JSON.parse(localStorage.getItem('blocker'))
    //   if (blockedFor && !moment(moment.now()).isAfter(+blockedFor)) {
    //   } else {
    //     if (attemptTime && moment(+attemptTime).isAfter(moment.now() - 36e5)) {
    //       document.cookie = `attempt=${+attempt + 1}; max-age=3600; path=/;`
    //       // this._cookie.set('attempt', `${+attempt + 1}`, moment.now() + 36e5, '/', 'localhost', true)
    //       let blockedTime = +attempt + 1 > 2 ? moment.now() + 36e5 * 24 : null
    //       if (blockedTime) {
    //         document.cookie = `blockerFor=${blockedTime}; max-age=86400; path=/;`
    //         // this._cookie.set('blockerFor', `${blockedTime}`, moment.now() + 36e5 * 24, '/', 'localhost', true)
    //       }
    // let blockerData = {
    //   attemptTime: oldBlockerData.attemptTime,
    //   attempt: oldBlockerData.attempt + 1,
    //   blockedFor: oldBlockerData.attempt + 1 > 2 ? moment.now() + 36e5 * 24 : null,
    // }
    // localStorage.setItem('blocker', JSON.stringify(blockerData))
    //     } else {
    //       document.cookie = `attempt=1; max-age=3600; path=/;`
    //       document.cookie = `attemptTime=${moment.now()}; max-age=3600; path=/;`
    //       // this._cookie.set('attempt', `1`, moment.now() + 36e5, '/', 'localhost', true)
    //       // this._cookie.set('attemptTime', `${moment.now()}`, moment.now() + 36e5, '/', 'localhost', true)
    //       if (blockedFor) {
    //         this._cookie.delete('blockerFor')
    //       }
    //     }
    //   }
    // } else {
    //   document.cookie = `attempt=1; max-age=3600; path=/;`
    //   document.cookie = `attemptTime=${moment.now()}; max-age=3600; path=/;`
    //   // this._cookie.set('attempt', `1`, moment.now() + 36e5, '/', 'localhost', true)
    //   // this._cookie.set('attemptTime', `${moment.now()}`, moment.now() + 36e5, '/', 'localhost', true)
    //   if (blockedFor) {
    //     this._cookie.delete('blockerFor')
    //   }
    //   }
    // }
    let idBlockerData = JSON.parse(localStorage.getItem('blocker'))
    this.idBlocker$.next(idBlockerData)
  }

  blocked() {}
}
//
